import { deepCloneSafe } from '@src/utility/deepCloneSafe';

import type { CurrentLoadedVideo } from '@src/stores/VideoCreatorStore';
import type { VideoVersion } from '@src/types.ts/story';

/** A clip Content Studio already holds, ready for Creator Studio to render. */
export type ClipSeed = {
  video: CurrentLoadedVideo;
  /** Version history the clip is loaded with; its own version is the latest. */
  versions: VideoVersion[];
};

/**
 * PLAT-11911 — the latest clip preview's clip, handed to Creator Studio's next
 * `loadVideo` so it renders without refetching. One slot, consumed once. Plain
 * state: nothing observes it. Held by reference and copied only when taken, so
 * a seed that's never used costs no clone.
 */
export class StudioHandoffStore {
  seed: ClipSeed | null = null;

  setSeed(seed: ClipSeed | null): void {
    this.seed = seed;
  }

  /**
   * A copy of the seed if it is for `videoId`, so Creator Studio's edits don't
   * reach the preview's objects. Always empties the slot.
   */
  takeSeed(videoId: string): ClipSeed | null {
    const seed = this.seed;
    this.seed = null;
    return seed?.video.id === videoId ? deepCloneSafe(seed) : null;
  }
}
